import React, { useEffect, useState } from 'react'
import { Button, Input, Select, Spin, } from 'antd'
import 'aos/dist/aos.css'
import '../MainCSS.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { BaseIPForPDF } from '../../AllAPI/CommonAPI/CommonApi'
import { GetOrderNoData, GetPackingListReportData, } from '../../AllAPI/SalesOrderReportAPI/SalesOrderReportApi'
import { Option } from 'antd/es/mentions'

const PackingList = () => {

   const commonHeaders1 = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
    },
  }

   const [errors, setErrors] = useState({
      orderNo: '',
      withRate: '',
    })

    const [allOrderNo , setAllOrderNo ] = useState([])
    const [orderNo, setOrderNo] = useState('')
    const [withRate, setWithRate] = useState('2')
    const [loading, setLoading] = useState(false)

      // Fetch OrderNo====
        let isOrderFetched = false;
        useEffect(() => {
          if (isOrderFetched) return;
          fetchOrderNo();
          isOrderFetched = true;
        }, []);


     //=========CANCEL SALES ITEM WISE REPORT DATA============
  const handleCancel = () => {
    setOrderNo('')
    setWithRate('1')
    setErrors('')
  }

  let isError = false;

   const fetchOrderNo = async () => {
    
      try {
        const response = await axios.get(GetOrderNoData,commonHeaders1);
        if (response.data !== null) {
          setAllOrderNo(response.data);
        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching Order No.:", error);
          toast.error("Failed to fetch Order No. data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };
  //=========GET SALES ITEM WISE REPORT DATA============
    const handleShowPdf = async () => {
    let isValid = true
    const errorObj = {}

     if (!orderNo) {
      isValid = false;
      errorObj.orderNo = "Order No. is required *";
    }

    setErrors(errorObj)
    if (!isValid) return

     const selectedOrder = allOrderNo.find(order => order.id === orderNo);
     const selectedOrderNoId = selectedOrder?.orderNumberId;


    try {
      const response = await axios.get(`${GetPackingListReportData}?orderNumberId=${selectedOrderNoId}&withRate=${withRate}`, commonHeaders1)

      if (response.data !== null) {
        if (
          response.data === 'NOTFOUND' ||
          response.data === 'NODATA' ||
          response.status === 204
        ) {  
          toast.warn('No data available!', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })

          setLoading(false)
          return // Exit function early
        }
  
        let reportUrl = response.data
        if (reportUrl === 'NOTFOUND') {
          toast.warn('Report File Not Found...!!', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })
        } else {
          const reportLink = BaseIPForPDF + `output/${reportUrl}`
          window.open(reportLink, '_blank')
        }
      }
    } catch (error) {
      setLoading(false)
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
    }


  return (
    <>
      <div className="px-5 py-3">
        <div
          className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
          style={{ backgroundColor: '#e0efff' }}
        >
          <div className="col-12">
            <div className="row px-md-5 mt-3 p-2">
                <div className="col-md-6 col-lg-2 py-1"></div>
                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Order No.</label>
                    <Select
                      value={orderNo || undefined}
                      onChange={(value) => setOrderNo(value)}
                      showSearch
                      className="w-100"
                      placeholder="Select Order No."
                      optionFilterProp="children"
                    >
                      {allOrderNo.map((order) => (
                        <Option key={order.id} value={order.id}>
                          {order.orderNumber}
                        </Option>
                      ))}
                    </Select>
                    {errors.orderNo && (
                      <div className="errorField">{errors.orderNo}</div>
                    )}
                  </div>
                 <div className="col-md-6 col-lg-4 py-1">
                          <label className="labels">With Rate</label>
                          <Select
                            value={withRate}
                            onChange={(value) => setWithRate(value)}
                            showSearch
                            className="w-100"
                            optionFilterProp="children"
                          >
                            <Option value="2">No</Option>
                            <Option value="1">Yes</Option>
                          </Select>
                          {errors.withRate && <div className="errorField">{errors.withRate}</div>}
                        </div>
                <div className="col-md-6 col-lg-2 py-1"></div>

                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="CancelBtn mx-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                    onClick={handleShowPdf}
                    disabled={loading}
                  >
                      {loading ? "Generating PDF..." : "View Report"}
                  </Button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PackingList